export default __webpack_public_path__ + "static/media/choice.8f570701.svg";